import React, { useContext } from 'react';
import classNames from "classnames";
import styles from './Benefits.module.css';
import { Row, Col, Container } from 'reactstrap';
import Growth from '../../assets/images/Vendor/HomeDepot/GrowthBanner.jpeg';
import Satisfaction from '../../assets/images/Vendor/HomeDepot/SatisfactionBanner.jpeg';
import Opportunities from '../../assets/images/Vendor/HomeDepot/OpportunitiesBanner.jpeg';
import BrandedIcon from '../../components/BrandingWhiteLabel/BrandedIcon';
import { SessionContext } from '../../context/SessionContext';

const Benefits = () => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;

    const serviceBenefits = (element) => {
        const serviceInfo1 = [
            'Adds revenue without overhead costs',
            'Profit margin on every sale',
            'Multiple reimbursement options'
        ];
        const serviceInfo2 = [
            'Protection for expensive repairs',
            'Service they can trust – by you',
            'Fully transferable, added resale benefit'
        ];
        const serviceInfo3 = [
            'Competitive advantage',
            'Increase customer referrals',
            'Long-term customer relationships'
        ];
        
        let infoArray = [];
        switch(element) {
            case 1: 
                infoArray = serviceInfo1;
                break;
            case 2: 
                infoArray = serviceInfo2;
                break;
            case 3: 
                infoArray = serviceInfo3;
                break;
            default: 
                infoArray = serviceInfo1;
        }

        return (
            infoArray.map((benefit, index) => {
                return <div key={index}>
                    <div>
                        <BrandedIcon
                            accountName={accountName}
                            iconType="checkwithcircle"
                        />
                    </div>
                    <div>{benefit}</div>
                </div>
            })
        );
    };

    return (
        <>
            <Container fluid className={styles.customerBenefitsOuterContainer}>
                <Container className={styles.customerBenefitsContainer}>
                    <Row>
                        <Col sm='12' md='12' lg='4' xl='4' className='p-0'>
                            <div className={styles.benefitsContainer}>
                                <div className={styles.serviceBenefitsHead}>
                                    <h1>More Growth</h1>
                                    <p>Benefits for You</p>
                                </div>
                                <div className={styles.serviceBenefitsContainer}>
                                    <img src={Growth} />
                                    <div>
                                        <div className={styles.serviceBenefitsHeadMd}>
                                            <h1>More Growth</h1>
                                            <p>Benefits for You</p>
                                        </div>
                                        <div className={styles.serviceBenefits}>                                        
                                            {serviceBenefits(1)}
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </Col>
                        <Col sm='12' md='12' lg='4' xl='4' className='p-0'>
                            <div className={styles.benefitsContainer}>
                                <div className={styles.serviceBenefitsHead}>
                                    <h1>More Satisfaction</h1>
                                    <p>Benefits for Them</p>
                                </div>
                                <div className={styles.serviceBenefitsContainer}>
                                    <img src={Satisfaction} />
                                    <div>
                                        <div className={styles.serviceBenefitsHeadMd}>
                                            <h1>More Satisfaction</h1>
                                            <p>Benefits for Them</p>
                                        </div>
                                        <div className={styles.serviceBenefits}>                                        
                                            {serviceBenefits(2)}
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </Col>
                        <Col sm='12' md='12' lg='4' xl='4' className='p-0'>
                            <div className={styles.benefitsContainer}>
                                <div className={styles.serviceBenefitsHead}>
                                    <h1>More Opportunities</h1>
                                    <p>Partner with The Home Depot</p>
                                </div>
                                <div className={styles.serviceBenefitsContainer}>
                                    <img src={Opportunities} />
                                    <div>
                                        <div className={styles.serviceBenefitsHeadMd}>
                                            <h1>More Opportunities</h1>
                                            <p>Partner with The Home Depot</p>
                                        </div>
                                        <div className={styles.serviceBenefits}>                                        
                                            {serviceBenefits(3)}
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Container fluid className={styles.coverageOuterContainer}>
                <Container className={styles.coverageContainer}>
                    <Row>
                        <Col className={styles.coverageContainerNoPadding}>
                            <h1>The Best Options in Labor Coverage</h1>
                            <p>3, 5 and 10-year Options</p>
                        </Col>
                    </Row>
                </Container>
                <Container className={classNames(styles.copyRightContainer)}>
                    <p className={styles.copyRight}>
                        Service contract plans are issued by Service Net Warranty, LLC, part of AIG, or its affiliates. Plans are subject to detailed terms and conditions. Review the full program sales and service guidelines 
                        for further information. AIG is the marketing name for the worldwide property-casualty and general insurance operations of American International Group, Inc. For additional information, please visit 
                        our website at <a href="https://www.aig.com" className={styles.benefitsLink}>www.aig.com</a>.
                    </p>
                    <p className={styles.copyRight}>
                        All trademarks are owned by their respective companies. The Home Depot trademarks are used with permission.
                    </p>
                </Container>
            </Container>
        </>
    );
};

export default Benefits;